// src/api/axios.ts
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true, // important if you're using cookies
});

let csrfToken = null;

export const fetchCsrfToken = async () => {
  const res = await api.get("/auth/csrf-token");
  csrfToken = res.data.csrfToken;
};

api.interceptors.request.use((config) => {
  if (csrfToken) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

export default api;
